// node modules
import { observable, action } from 'mobx';
import { computedFn } from 'mobx-utils';
// consts
import { INITIAL_LOADINGS } from './consts';

export default class LoadingStore {
  @observable loadings: LoadingList = INITIAL_LOADINGS;
  @observable childLoading: ChildLoadingList = {};

  getLoading = computedFn((key: LoadingKey) => this.loadings[key]);
  getChildLoading = computedFn(
    (key: LoadingKey, childKey: string) => this.childLoading[key]?.[childKey],
  );

  @action setLoading = (key: LoadingKey, value: boolean) => {
    this.loadings[key] = value;
  };

  @action setChildLoading = (
    key: LoadingKey,
    childKey: string,
    value: boolean,
  ) => {
    if (!this.childLoading[key]) {
      this.childLoading[key] = {};
    }

    this.childLoading[key]![childKey] = value;
  };
}
